"use strict";
// Connection locks are independent of the existence of connections
// that is why this class is needed
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionLockStates = void 0;
class ConnectionLockStates {
    localLocks = new Map();
    remoteLocks = new Map();
    // TODO: remove weakLocks use localLocks instead. When opening weakLocks from the ConnectioManager,
    // simply do not send lock requests.
    weakLocks = new Map();
    // Used to filter proxy connections from the connections view
    remotePrivateConnections = new Set();
    getLocalLockedConnectionCount() {
        return this.localLocks.size;
    }
    getRemoteLockedConnectionCount() {
        return this.remoteLocks.size;
    }
    getWeakLockedConnectionCount() {
        return this.weakLocks.size;
    }
    isLocalLocked(id, lockId) {
        if (lockId === undefined) {
            return this.localLocks.has(id);
        }
        else {
            return this.localLocks.has(id) && this.localLocks.get(id).has(lockId);
        }
    }
    isRemoteLocked(id, lockId) {
        if (lockId === undefined) {
            return this.remoteLocks.has(id);
        }
        else if (this.remoteLocks.has(id) && this.remoteLocks.get(id).has(lockId)) {
            return true;
        }
        else {
            return false;
        }
    }
    isWeakLocked(id) {
        return this.weakLocks.has(id);
    }
    isLocked(id) {
        return (this.isLocalLocked(id) || this.isRemoteLocked(id) || this.isWeakLocked(id));
    }
    addLocalLocked(id, lockId) {
        if (!this.localLocks.has(id)) {
            this.localLocks.set(id, new Set());
        }
        this.localLocks.get(id).add(lockId);
    }
    addRemoteLocked(id, lockId) {
        if (!this.remoteLocks.has(id)) {
            this.remoteLocks.set(id, new Set());
        }
        this.remoteLocks.get(id).add(lockId);
    }
    addWeakLocked(id, lockId) {
        if (!this.weakLocks.has(id)) {
            this.weakLocks.set(id, new Set());
        }
        this.weakLocks.get(id).add(lockId);
    }
    removeLocalLocked(id, lockId) {
        if (this.localLocks.has(id)) {
            this.localLocks.get(id)?.delete(lockId);
            if (this.localLocks.get(id)?.size === 0) {
                this.localLocks.delete(id);
            }
        }
    }
    removeRemoteLocked(id, lockId) {
        if (this.remoteLocks.has(id)) {
            this.remoteLocks.get(id)?.delete(lockId);
            if (this.remoteLocks.get(id)?.size === 0) {
                this.remoteLocks.delete(id);
            }
        }
    }
    removeWeakLocked(id, lockId) {
        if (this.weakLocks.has(id)) {
            this.weakLocks.get(id)?.delete(lockId);
            if (this.weakLocks.get(id)?.size === 0) {
                this.weakLocks.delete(id);
            }
        }
    }
    addPrivate(id) {
        this.remotePrivateConnections.add(id);
    }
    removePrivate(id) {
        this.remotePrivateConnections.delete(id);
    }
    getPrivateConnections() {
        return this.remotePrivateConnections;
    }
    isPrivate(id) {
        return this.remotePrivateConnections.has(id);
    }
    clearAllLocks(id) {
        this.localLocks.delete(id);
        this.remoteLocks.delete(id);
        this.weakLocks.delete(id);
    }
    clear() {
        this.localLocks.clear();
        this.remoteLocks.clear();
        this.weakLocks.clear();
    }
}
exports.ConnectionLockStates = ConnectionLockStates;
//# sourceMappingURL=ConnectionLockStates.js.map